import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { HelpEffectsModule } from '@appStore/help/effects';
import { reducers } from '@appStore/help/reducers';
import * as fromServices from '@appStore/help/services';

export * from '@appStore/help/reducers';
export * from '@appStore/help/effects';
export * from '@appStore/help/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('help', reducers), HelpEffectsModule],
  providers: [...fromServices.services]
})
export class HelpStoreModule {}
